import { invokeApi } from '../bl_libs/invokeApi';
import { use_e2ee } from '../utils/utils';
import { LOCAL_STORAGE_KEYS } from '../utils/constants';

const getToken = () => JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.auth_token));

/**
 * Products the insider's package marks "available" (self-activatable),
 * each with an `is_active` flag.
 * Response: { data: { products: [{ product_key, label, description, category, permissions, is_active }] } }
 */
export const getAvailableProductsService = () => {
    return invokeApi({
        path: '/dq_insider/products/available',
        method: 'GET',
        headers: { Authorization: `Bearer ${getToken()}` },
    }, use_e2ee());
};

/**
 * Self-activate an available product. Backend invalidates the session —
 * re-fetch the session afterwards so product_access reflects the change.
 */
export const activateProductService = (product_key) => {
    return invokeApi({
        path: '/dq_insider/products/activate',
        method: 'POST',
        headers: { Authorization: `Bearer ${getToken()}` },
        postData: { product_key },
    }, use_e2ee());
};

/**
 * Deactivate a self-activated product.
 */
export const deactivateProductService = (product_key) => {
    return invokeApi({
        path: '/dq_insider/products/deactivate',
        method: 'POST',
        headers: { Authorization: `Bearer ${getToken()}` },
        postData: { product_key },
    }, use_e2ee());
};
